{
  "version": 1,
  "asset_id": "d26cd38f-90ee-420b-b934-612a2baab4c2",
  "project_id": "a3729fa2-e85b-4f5b-84b2-0934e880c580",
  "url": "/__l5e/assets-v1/d26cd38f-90ee-420b-b934-612a2baab4c2/palworld-storage-box.webp",
  "r2_key": "a/v1/a3729fa2-e85b-4f5b-84b2-0934e880c580/d26cd38f-90ee-420b-b934-612a2baab4c2/palworld-storage-box.webp",
  "original_filename": "palworld-storage-box.webp",
  "size": 109398,
  "content_type": "image/webp",
  "created_at": "2026-09-01T00:36:27Z"
}
